export default "__VITE_ASSET__BNfmr10X__"